
import { TranslationService } from "@/core/services/TranslationService";
import { FormatMethods } from "@/helpers/data-format";
import VZKeyValue from "@/components/content/VZKeyValue.vue";
import { computed, defineComponent, PropType, toRefs } from "vue";
import { IRole } from "@/interfaces/iRole";
export default defineComponent({
  name: "role-detail",
  inheritAttrs: false,
  components: { VZKeyValue },
  props: {
    data: { type: Object as PropType<IRole>, required: true },
    showCard: { type: Boolean, required: false, default: true },
  },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const { data } = toRefs(props);

    const format = computed(() => {
      return FormatMethods;
    });
    const items = computed(() => {
      return [
        {
          header: t("common.name"),
          value: data.value.roleName,
        },

        {
          header: t("common.status"),
          value: data.value.status
            ? format.value.TitleCase(data.value.status?.toLowerCase())
            : "",
          valueClass:
            data.value.status?.toLowerCase() === "active"
              ? "badge badge-success bg-success"
              : "badge badge-danger bg-danger",
        },
        {
          header: t("common.createdDate"),
          value: data.value.createdDate
            ? format.value.DateTime(data.value.createdDate)
            : "",
        },
        {
          header: t("common.createdBy"),
          value: data.value.createdBy,
        },
        {
          header: t("common.updatedDate"),
          value: data.value.updateDate
            ? format.value.DateTime(data.value.updateDate)
            : "",
        },
        {
          header: t("common.updatedBy"),
          value: data.value.updatedBy,
        },
      ];
    });

    return {
      t,
      format,
      items,
    };
  },
});
